import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DControlLabel = _resolveComponent("DControlLabel")!
  const _directive_observe_visibility = _resolveDirective("observe-visibility")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-control-descriptor", { error: $props.errors[$props.name] || !$setup.isValid, success: $props.isSuccess }])
  }, [
    _createElementVNode("pre", null, _toDisplayString($props.searchable), 1),
    _createVNode($setup["VueMultiselect"], _mergeProps({ class: "d-control-descriptor__element" }, _ctx.$attrs, {
      options: $props.options,
      label: $props.labelBy,
      "track-by": $props.trackBy,
      placeholder: $props.placeholder,
      disabled: $props.disabled,
      "allow-empty": $props.allowEmpty,
      modelValue: $setup.model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.model) = $event)),
      searchable: $props.searchable,
      required: $props.rules,
      value: $setup.model,
      onRemove: $setup.removeEventHandler,
      "open-direction": 'top'
    }), _createSlots({ _: 2 }, [
      _renderList($setup.eSlots, (name, key) => {
        return {
          name: name,
          fn: _withCtx((binded) => [
            _renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(binded)))
          ])
        }
      }),
      ($props.pagination && Math.ceil($props.pagination.total/$props.pagination.page_size) > $props.pagination.page)
        ? {
            name: "afterList",
            fn: _withCtx(() => [
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("div", null, null, 512), [
                  [_directive_observe_visibility, $setup.visibilityChanged]
                ])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1040, ["options", "label", "track-by", "placeholder", "disabled", "allow-empty", "modelValue", "searchable", "required", "value"]),
    ($props.controlLabel)
      ? (_openBlock(), _createBlock(_component_DControlLabel, _mergeProps({
          key: 0,
          class: ["d-control-input__label--static", {'d-control-input__label--disabled': $props.disabled }],
          "input-label": $props.staticLabel ? $props.staticLabel : $props.inputLabel,
          "is-required": $setup.containsRequired($setup.props.rules)
        }, _ctx.$attrs, { value: _ctx.inputValue }), null, 16, ["class", "input-label", "is-required", "value"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "inputlabel")
  ], 2))
}